<div class="row account-selector align-content-end">
  <div class="input-group justify-content-end input-group-container">
    <span class="input-group-text bg-transparent z-1 filter-container w-100">
      <a class="nav-link dropdown-toggle w-100" href="#" role="button" aria-expanded="false" data-bs-toggle="dropdown"
        data-bs-auto-close="outside" #dropdownTrigger [attr.data-bs-offset]="positionOffset">
        <i class="ph ph-funnel-simple" *ngIf="isFilter"></i>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" *ngIf="!isFilter">
          <path d="M12.6667 6.66671H3.33333C2.598 6.66671 2 7.26471 2 8.00004V13.3334C2 14.0687 2.598 14.6667 3.33333 14.6667H12.6667C13.402 14.6667 14 14.0687 14 13.3334V8.00004C14 7.26471 13.402 6.66671 12.6667 6.66671ZM3.33333 13.3334V8.00004H12.6667L12.668 13.3334H3.33333ZM3.33333 4.00004H12.6667V5.33337H3.33333V4.00004ZM4.66667 1.33337H11.3333V2.66671H4.66667V1.33337Z" fill="#9FA1A4"/>
        </svg>
        <span class="text-dark" *ngIf="!selectedAccount?.id">{{ isLoading ? 'Loading accounts ...' : isFilter ? 'Filter by account' : 'Select Account' }}</span>
        <span class="text-dark" *ngIf="selectedAccount?.id">{{ selectedAccount?.name }}</span>
      </a>

      <ul class="dropdown-menu custom-dropdown border-0 position-fixed" #dropdown>
        <div class="sticky-top bg-white p-2">
          <div class="input-group align-items-center">
            <div
              class="col-1 ps-2 d-flex justify-content-center align-items-center rounded-start-3 border-1 search-icon">
              <i class="ph ph-magnifying-glass"></i>
            </div>

            <div class="col-11">
              <input type="text" class="ps-3 rounded-end-3 border-1 search-input" aria-label="Search" [placeholder]="
              isLoading ? 'Loading accounts ...' : 'Search accounts'" [(ngModel)]="accountName"
                (input)="searchAccounts($event)" (click)="openDropdown($event)" />
            </div>
          </div>
        </div>

        <div class="dropdown-scroll">
          <ng-container *ngTemplateOutlet="accountsTreeList; context: { items: filteredTree }"></ng-container>
        </div>
      </ul>

      <ng-template #accountsTreeList let-items="items">
        <li *ngFor="let item of items; let i = index" class="dropdown-item">
          <label [ngClass]="{
              'parent-item':
                item.hierarchyLevel === 0 || item.children?.length > 0
            }">
            <input type="checkbox" [(ngModel)]="item.checked" (click)="onCheckboxChange($event, item)" />
            {{ item.name }}
          </label>
          <ul *ngIf="item.children?.length">
            <ng-container *ngTemplateOutlet="
                accountsTreeList;
                context: { items: item.children }
              "></ng-container>
          </ul>
          <div *ngIf=" item.hierarchyLevel === 1 && item.children?.length" class="hierarchy-line"></div>
        </li>
      </ng-template>
    </span>
  </div>
</div>